export const labels = {
	options: {
		label: "Label.MobileCreator.BottomMenu.Root.Options",
		default: "Options",
	},
	photo: {
		label: "Label.MobileCreator.BottomMenu.Root.Photo",
		default: "Photos",
	},
	map: {
		label: "Label.MobileCreator.BottomMenu.Root.Maps",
		default: "Maps",
	},
	text: {
		label: "Label.MobileCreator.BottomMenu.Root.Text",
		default: "Text",
	},
	backgrounds: {
		label: "Label.MobileCreator.BottomMenu.Root.Backgrounds",
		default: "Backgrounds",
		// description: "Label shown below icon in bottom menu. Opens a menu where user can apply backgrounds such as colors, patterns and photos to the product."
	},
	templates: {
		label: "Label.MobileCreator.BottomMenu.Root.Templates",
		default: "Layout",
		// description: "Label shown below icon in bottom menu. Opens a menu where user can apply templates."
	},
	designs: {
		label: "Label.MobileCreator.BottomMenu.Root.Designs",
		default: "Designs",
	},
	symbols: {
		label: "Label.MobileCreator.BottomMenu.Root.Symbols",
		default: "Symbols",
	},
	events: {
		label: "Label.MobileCreator.BottomMenu.Root.Events",
		default: "Events",
	},
} as const;
